/** Words retain authored character ranges, including italic markers, for narration progress. */
export function subtitleWords(text) {
    const parts = [];
    const italics = [...text.matchAll(/\*(\S(?:[^*\r\n]*\S)?)\*/g)]
        .map(match => ({ start: match.index, end: match.index + match[0].length - 1 }));
    const markers = new Set(italics.flatMap(range => [range.start, range.end]));
    for (const match of text.matchAll(/(\S+)|(\s+)/g)) {
        if (!match[1]) {
            parts.push(match[0]);
            continue;
        }
        const start = match.index;
        const end = start + match[1].length;
        const italic = italics.some(range => start <= range.end && end > range.start);
        parts.push({ text: match[1].split('').filter((_, index) => !markers.has(start + index)).join(''),
            start, end, ...(italic ? { italic: true } : {}) });
    }
    return parts;
}
export function spokenWordFraction(word, offset) {
    return Math.min(1, Math.max(0, (offset - word.start) / (word.end - word.start)));
}
